<template>
  <div>
    <button class="btn btn-danger" @click="getScrapperLogs" title='Ver logs'><i class='glyphicon glyphicon-time'></i></button>
    <button class="btn btn-danger" data-toggle="modal" data-target="#exampleModal" id="btnModal" style="visibility:hidden;" ></button>
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Historial de eventos</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table" id="content-table-scrapper">
              <thead>
                <tr>
                  <th scope="col">Fecha</th>
                  <th scope="col">Proceso</th>
                  <th scope="col">Status</th>
                  <th scope="col">Evento</th>
                </tr>
              </thead>
              <tbody id="tbody">
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name:'ScrappersLogsTable',
  props:['url','name'],
  data(){
    return{
      scrappers:[],
      translates:{
        pending:"Pendiente por ejecutar",
        in_process:"En ejecución",
        done:'Ejecutado con exito',
        errors:'Ocurrió un error',
        in_progress: 'En ejecución',
        retrying: 'Reintentando'
      }
    }

  },
  methods:{
    async getScrapperLogs(){
      let tbody = document.getElementById('tbody')
      tbody.innerHTML = ''
      const url = `/scrapper_logs?project_id=${this.url}&scrapper_name=${this.name}`
      console.log(url)
      const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
			axios.defaults.headers['x-csrf-token'] = token
			axios.defaults.headers.common['Accept'] = 'application/json';
      axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

      const result = await axios.get(url)
      this.scrappers = result.data
      const optionsTime = {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      };
      for(let i = 0; i<this.scrappers.length;i++){
        let scrapper = this.scrappers[i]
        let tr = document.createElement('tr')
        let tdFecha = document.createElement('td')
        let tdHora = document.createElement('td')
        let tdId = document.createElement('td')
        let tdStatus = document.createElement('td')
        let tdEvent = document.createElement('td')
        tdFecha.innerText = new Date(scrapper.created_at).toISOString().substr(0,10) + ' ' + new Date(scrapper.created_at).toLocaleString('en-US', optionsTime)
        tdFecha.style = "font-size:14px; width:28%;"
        tr.appendChild(tdFecha)
        tdId.innerText = scrapper.project_id
        tr.appendChild(tdId)
        tdStatus.innerText = this.translates[scrapper.status]
        tr.appendChild(tdStatus)
        let event = scrapper.event.event
        if(event.includes('Params')){
          event = event.split('Params')
          tdEvent.innerText = event[0]
        }else{
          tdEvent.innerText = scrapper.event.event
        }

        tr.appendChild(tdEvent)
        tbody.appendChild(tr)
      }
      let dialog = document.getElementsByClassName('modal-dialog')
      dialog[1].style = "width:707px;"
      document.getElementById('btnModal').click()
    }
  }
}
</script>

<style>

</style>